import React from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { saveAs } from 'file-saver';
import { Button } from '@mui/material';
import SimCardDownloadRoundedIcon from '@mui/icons-material/SimCardDownloadRounded';
const PaySlipPdf = ({
  paySlip,
  company_logo,
  workingData,
  payslipMonthRange,
}) => {
  const generatePDF = async () => {
    console.log('Generating PDF for payslip:', paySlip);
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([600, 850]);
    const { width, height } = page.getSize();
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    // Add Company Logo on the left side
    const logoImageBytes = await fetch(paySlip.company_logo).then((res) =>
      res.arrayBuffer()
    );
    const logoImage = await pdfDoc.embedJpg(logoImageBytes);
    const logoDims = logoImage.scale(0.17); // Scale the logo to fit nicely
    page.drawImage(logoImage, {
      x: 360,
      y: height - logoDims.height - 85,
      width: logoDims.width,
      height: logoDims.height,
    });
    // Add Company Name in the center
    const companyName = paySlip.company_name || 'KG BUILD TECH';
    const textWidth = fontBold.widthOfTextAtSize(companyName, 18);

    // page.drawText(companyName, {
    //   x: (width - textWidth) / 2,
    //   y: height - 100,
    //   size: 15,
    //   font: fontBold,
    //   color: rgb(0, 0.4, 0.8),
    // });

    page.drawText(paySlip.address, {
      x: 350,
      y: height - 163,
      size: 9,
      font,
      color: rgb(0, 0, 0),
    });

    // Add Date on the right side
    page.drawText(`Payslip break down: ${payslipMonthRange}`, {
      x: 350,
      y: height - 179,
      size: 9,
      font: fontBold,
      color: rgb(0, 0, 0),
    });
    page.drawLine({
      start: { x: 30, y: height - 50 },
      end: { x: width - 30, y: height - 50 },
      thickness: 1,
      color: rgb(0, 0, 0),
    });
    // Employee details below the header
    const detailsY = height - 100;
    page.drawText(`Employee Name`, {
      x: 33,
      y: detailsY,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.employee_name, {
      x: 160,
      y: detailsY,
      size: 10,
      font,
    });

    page.drawText(`Employee ID`, {
      x: 33,
      y: detailsY - 20,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.employee_no, {
      x: 160,
      y: detailsY - 20,
      size: 10,
      font,
    });

    page.drawText(`Designation`, {
      x: 33,
      y: detailsY - 40,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.position, {
      x: 160,
      y: detailsY - 40,
      size: 10,
      font,
    });

    page.drawText(`Company Name`, {
      x: 33,
      y: detailsY - 60,
      size: 10,
      font: fontBold,
    });
    page.drawText(companyName, {
      x: 160,
      y: detailsY - 60,
      size: 10,
      font,
    });

    page.drawText(`Department`, {
      x: 33,
      y: detailsY - 80,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.department_name, {
      x: 160,
      y: detailsY - 80,
      size: 10,
      font,
    });

    page.drawText(`Bank Name`, {
      x: 33,
      y: detailsY - 100,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.bank_name, {
      x: 160,
      y: detailsY - 100,
      size: 10,
      font,
    });

    page.drawText(`A/c. Number`, {
      x: 33,
      y: detailsY - 120,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.account_number, {
      x: 160,
      y: detailsY - 120,
      size: 10,
      font,
    });

    // Add Table

    // Draw rows for emoluments and deductions
    const emoluments = [
      { label: 'Actual Salary', value: paySlip.actual_pay },
      { label: 'Basic Salary', value: paySlip.basic_pay },
      { label: 'HRA', value: paySlip.house_allowance },
      { label: 'Medical Allowance', value: paySlip.medical_allowance },
      { label: 'Conveyance Allowance', value: paySlip.vehicle_allowance },
      {
        label: 'Employee Provident Fund (EPF)(12%) above 21000',
        value: paySlip.epf_fund,
      },
      // professional tax need to check (PT)
      {
        label: 'Professional Tax (PT)(200 TO 2000)',
        value: paySlip.professional_tax ?? 0,
      },
      {
        label: 'Tax Deducted at Source (TDS)(above 75000 5%)',
        value: paySlip.income_tax,
      },
      { label: 'ESI', value: paySlip.rd_esi ?? 0 },
      { label: 'Other Allowance', value: paySlip.other_allowance },
      { label: 'OT Hrs', value: paySlip.ot_hrs },
      {
        label: 'Dearness Allowance',
        value:
          paySlip.company_name?.trim().toUpperCase() === 'KG FURN TECH'
            ? (paySlip.dearness_allowance ?? 0).toLocaleString()
            : '0',
      },
      { label: ' ', value: ' ' },
      // { label: 'Days Paid', value: paySlip.no_of_days_working },
      { label: 'Gross Pay', value: paySlip.gross_pay, bold: true },
    ];
    const deductions = [
      { label: 'Total Days', value: workingData?.totalDays },
      { label: 'Full Days', value: paySlip.full_days },
      { label: 'Half Days', value: paySlip.half_days },
      { label: 'Medical Leave or Sick Leave', value: ' ' }, // Medical Leave or Sick Leave
      { label: 'Privilege Leave', value: ' ' }, // Privilege Leave
      { label: 'Casual Leave', value: ' ' }, // Casual Leave
      {
        label: 'Leave taken by employee',
        value: paySlip.no_of_days_leave_taken,
      },
      { label: 'Weekend(Sunday) + Holiday', value: workingData.sundays },
      { label: 'Employee Advance', value: paySlip.employee_advance }, // Employee Advance
      { label: 'Salary Advance (Same Month)', value: paySlip.salary_advance },
      {
        label: 'Personal Advance (Monthly Wise)',
        value: paySlip.personal_advance,
      },
      // { label: 'RD /ESI /EPFO', value: paySlip.rd_esi },
      // { label: 'Life Insurance Corporation', value: paySlip.life_insurance },
      // {
      //   label: 'Postal Life Insurance',
      //   value: paySlip.personal_life_insurance,
      // },
      // { label: 'Income Tax(TDS)', value: paySlip.income_tax },
      // { label: 'Loss of Pay', value: paySlip.leave_amount },
      // { label: 'Total Deductions', value: paySlip.total_deductions },
      // {
      //   label: 'No of Days leave taken',
      //   value: paySlip.no_of_days_leave_taken,
      // },
      {
        label: 'Total Deductions',
        value: paySlip.total_deductions,
        bold: true,
      },
      { label: 'Net Pay', value: paySlip.net_pay, bold: true },
      {
        label: 'Balance Advance',
        value: paySlip.balance_advance ?? 0,
        bold: true,
      },
    ];

    // Define table dimensions
    const tableX = 25; // Starting X position
    const tableY = height - 250; // Starting Y position
    const cellHeight = 20;
    const col1Width = 245; // Column 1 width
    const col2Width = 65; // Column 2 width
    const col3Width = 170; // Column 3 width
    const col4Width = 65; // Column 4 width

    const col1X = tableX;
    const col2X = col1X + col1Width;
    const col3X = col2X + col2Width;
    const col4X = col3X + col3Width;

    // Draw table headers
    page.drawRectangle({
      x: tableX,
      y: tableY - cellHeight,
      width: col4X + col4Width - tableX,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    page.drawText('Emoluments', {
      x: col1X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 10,
    });

    page.drawText('Amount Rs.', {
      x: col2X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 10,
    });

    page.drawText('Deductions', {
      x: col3X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 10,
    });

    page.drawText('Amount Rs.', {
      x: col4X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 10,
    });

    const maxLength = Math.max(emoluments.length, deductions.length);

    for (let i = 0; i < maxLength; i++) {
      const yPos = tableY - (i + 2) * cellHeight;

      const emolument = emoluments[i];
      const deduction = deductions[i];

      // --- Emoluments side ---
      page.drawRectangle({
        x: col1X,
        y: yPos,
        width: col2X - col1X,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
      });

      page.drawRectangle({
        x: col2X,
        y: yPos,
        width: col3X - col2X,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
      });

      if (emolument) {
        page.drawText(emolument.label || '', {
          x: col1X + 5,
          y: yPos + 5,
          font: emolument.bold ? fontBold : font,
          size: 10,
        });

        page.drawText((emolument.value || '').toLocaleString?.() || '', {
          x: col2X + 5,
          y: yPos + 5,
          font: emolument.bold ? fontBold : font,
          size: 10,
          textAlign: 'right',
        });
      }

      // --- Deductions side ---
      page.drawRectangle({
        x: col3X,
        y: yPos,
        width: col4X - col3X,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
      });

      page.drawRectangle({
        x: col4X,
        y: yPos,
        width: col4Width,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
      });

      if (deduction) {
        page.drawText(deduction.label || '', {
          x: col3X + 5,
          y: yPos + 5,
          font: deduction.bold ? fontBold : font,
          size: 10,
        });

        page.drawText((deduction.value ?? '').toLocaleString?.() || '', {
          x: col4X + 5,
          y: yPos + 5,
          font: deduction.bold ? fontBold : font,
          size: 10,
          textAlign: 'right',
        });
      }
    }

    // system generated payslip
    const systemMessageY = tableY - (maxLength + 2) * cellHeight;
    const message = 'THIS IS SYSTEM GENERATED PAYSLIP';
    const deductionCellWidth = col4X + col4Width - col3X;
    const lightGray = rgb(0.6, 0.6, 0.6);

    // Draw empty emoluments side to keep alignment
    page.drawRectangle({
      x: col1X,
      y: systemMessageY,
      width: col2X - col1X,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });
    page.drawRectangle({
      x: col2X,
      y: systemMessageY,
      width: col3X - col2X,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    // Draw full-width deductions area (col3 + col4)
    page.drawRectangle({
      x: col3X,
      y: systemMessageY,
      width: deductionCellWidth,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    // Center text in deduction area
    const messageTextWidth = font.widthOfTextAtSize(message, 10);
    const messageCenterX = col3X + (deductionCellWidth - messageTextWidth) / 2;

    page.drawText(message, {
      x: messageCenterX,
      y: systemMessageY + 5,
      font: fontBold,
      size: 10,
      color: lightGray,
    });

    // Signature section setup
    const signatureHeight = cellHeight * 5;
    const signatureY = systemMessageY - signatureHeight;

    const fullSignatureWidth = col4X + col4Width - col1X;
    const emolumentsWidth = col2X - col1X;
    const deductionsWidth = col4X + col4Width - col3X;

    // 1. Draw full connected signature area
    page.drawRectangle({
      x: col1X,
      y: signatureY,
      width: fullSignatureWidth,
      height: signatureHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    // 2. Draw vertical dividing line to split left/right sides
    page.drawLine({
      start: { x: col3X, y: signatureY },
      end: { x: col3X, y: signatureY + signatureHeight },
      thickness: 1,
      color: rgb(0, 0, 0),
    });

    page.drawLine({
      start: { x: col2X, y: signatureY },
      end: { x: col2X, y: signatureY + signatureHeight },
      thickness: 1,
      color: rgb(0, 0, 0),
    });

    // 3. Add centered signature text in Emoluments side
    const leftText = 'Employee Signature';
    const leftTextWidth = font.widthOfTextAtSize(leftText, 10);
    const leftTextX = col1X + (emolumentsWidth - leftTextWidth) / 2;

    page.drawText(leftText, {
      x: leftTextX,
      y: signatureY + 5,
      font,
      size: 10,
    });

    // 4. Add centered signature text in Deductions side
    const rightText = 'Employee Signature';
    const rightTextWidth = font.widthOfTextAtSize(rightText, 10);
    const rightTextX = col3X + (deductionsWidth - rightTextWidth) / 2;

    page.drawText(rightText, {
      x: rightTextX,
      y: signatureY + 5,
      font,
      size: 10,
    });

    const drawFooter = async (page, pageNumber) => {
      const { width } = page.getSize();
      const margin = 30;
      const fontSize = 10;
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

      page.drawLine({
        start: { x: margin, y: margin },
        end: { x: width - margin, y: margin },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      page.drawText(`KG Build Tech`, {
        x: width / 2 - 10,
        y: margin - 20,
        size: fontSize,
        font,
        color: rgb(0, 0.4, 0.8),
      });
      page.drawText(` • ${pageNumber} • `, {
        x: width - margin - 50,
        y: margin - 20,
        size: fontSize,
        font,
        color: rgb(0, 0.4, 0.8),
      });
    };

    drawFooter(page, 1);

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    saveAs(
      blob,
      `payslip_${paySlip.employee_name}_${paySlip.payslip_date}.pdf`
    );
  };
  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        size='large'
        startIcon={<SimCardDownloadRoundedIcon />}
        onClick={generatePDF}
        sx={{
          backgroundColor: '#2196f3',
          fontWeight: 'bold',
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            backgroundColor: '#FFF',
            color: '#2196f3',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        Generate PDF
      </Button>
    </div>
  );
};
export default PaySlipPdf;
